<template>
  <div class="fa">
    <div
      class="box"
      :class="el_steps == 'el-steps' ? '' : 'box-small'"
      shadow="always"
    >
      <div style="width:80%;">
        <el-steps
          :class="el_steps"
          style=""
          :active="active"
          finish-status="success"
        >
          <el-step title="资质信息"></el-step>
          <el-step title="基础信息"></el-step>
          <el-step title="结算信息"></el-step>
          <el-step title="核对校验"></el-step>
        </el-steps>
      </div>
      <div>
        <div class="card-form">
          <div v-show="active == 0">
            <div
              :style="el_steps == 'el-steps' ? 'height:500px' : 'height:440px'"
            >
              <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%">
                <el-form
                  status-icon
                  :model="shop_info"
                  :rules="baserules"
                  ref="baseForm"
                  class="el-form-pc"
                  label-width="180px"
                  label-position="right"
                >
                  <el-form-item
                    class="validate-must"
                    label="是否预授权："
                    prop="is_pre_auth"
                  >
                    <el-radio-group v-model="shop_info.is_pre_auth">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="店铺密码：" prop="pass_word">
                    <el-input
                      v-model="shop_info.pass_word"
                      show-password
                      placeholder="店铺登录需要的参数"
                    ></el-input
                  ></el-form-item>
                  <el-form-item label="营业执照照片：" prop="img_license">
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'yyzz'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                    >
                      <template slot="centerName">
                        营业执照
                      </template>
                    </uploadImg>
                  </el-form-item>
                  <el-form-item label="店铺名称：" prop="mch_name">
                    <el-input
                      v-model="shop_info.mch_name"
                      placeholder="进件的店铺名称，可以通过营业执照识别"
                    ></el-input
                  ></el-form-item>
                  <el-form-item label="营业执照id：" prop="license_code">
                    <el-input
                      v-model="shop_info.license_code"
                      placeholder="营业执照注册号，可以通过营业执照识别"
                    ></el-input
                  ></el-form-item>
                  <el-form-item
                    label="营业执照有效期："
                    prop="license_start_date"
                  >
                    <el-col :span="8">
                      <el-date-picker
                        clearable
                        type="date"
                        placeholder="开始日期"
                        v-model="shop_info.license_start_date"
                        style="width: 100%;"
                        @change="getDate($event, 'license_start_date')"
                      ></el-date-picker>
                    </el-col>
                    <el-col :span="1">-</el-col>
                    <el-col :span="8">
                      <el-date-picker
                        clearable
                        type="date"
                        placeholder="截止日期(长期则不选)"
                        v-model="shop_info.license_expire_in"
                        @change="getDate($event, 'license_expire_in')"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="店铺地址：" prop="address"
                    ><el-input
                      v-model="shop_info.address"
                      placeholder="填写店铺所在地的详细地址，可以通过营业执照识别"
                    ></el-input
                  ></el-form-item>
                  <el-form-item label="资质类型：" prop="mch_type">
                    <el-select
                      class="qualification-type-select"
                      v-model="shop_info.mch_type"
                      placeholder="选择店铺的资质类型"
                    >
                      <el-option
                        v-for="item in mch_type_options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="经营范围：" prop="business_scope">
                    <el-select
                      v-model="shop_info.business_scope"
                      filterable
                      placeholder="经营范围(可通过输入的内容搜索)"
                    >
                      <el-option
                        v-for="item in MCC"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="店铺省市区：" prop="address_code">
                    <el-cascader
                      placeholder="选择店铺的省市区"
                      v-model="shop_info.address_code"
                      class="qualification-type-select"
                      :options="provincearr"
                      @change="shophandleChange"
                      :filterable="true"
                      :clearable="true"
                    ></el-cascader>
                  </el-form-item>

                  <el-form-item label="店铺门头照：" prop="img_door">
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'store_entrance'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                    >
                      <template slot="centerName">
                        店铺门头照
                      </template>
                    </uploadImg>
                  </el-form-item>

                  <el-form-item label="店铺内景照片：" prop="img_in_door">
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'indoor'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                    >
                      <template slot="centerName">
                        店铺内景照片
                      </template>
                    </uploadImg>
                  </el-form-item>
                  <el-form-item label="收银台照片：">
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'cashier'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                    >
                      <template slot="centerName">
                        收银台照片
                      </template>
                    </uploadImg>
                  </el-form-item>
                </el-form>
              </el-scrollbar>
            </div>
          </div>
          <div v-show="active == 1">
            <div
              :style="el_steps == 'el-steps' ? 'height:500px' : 'height:440px'"
            >
              <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%">
                <el-form
                  :model="shop_info"
                  :rules="legalrules"
                  ref="legalForm"
                  label-width="180px"
                  label-position="right："
                >
                  <el-form-item
                    label="法人身份证："
                    prop="img_legal_id_front"
                  >
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'zm'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                      style="display:inline-block"
                    >
                      <template slot="centerName">
                        法人身份证正面
                      </template>
                    </uploadImg>
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'fm'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                      style="display:inline-block; margin-left: 10px;"
                    >
                      <template slot="centerName">
                        身份证反面照片
                      </template>
                    </uploadImg>
                  </el-form-item>
                  <!-- <el-form-item label="开户银行卡照片：" prop="img_bank_card">
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'bank'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                    >
                      <template slot="centerName">
                        银行卡
                      </template>
                    </uploadImg>
                  </el-form-item> -->
                  <el-form-item label="法人姓名：" prop="legal_person_name"
                    ><el-input
                      v-model="shop_info.legal_person_name"
                      placeholder="请填写法人姓名，可通过法人身份证识别"
                    ></el-input
                  ></el-form-item>
                  <el-form-item label="法人身份证号：" prop="legal_person_id"
                    ><el-input
                      v-model="shop_info.legal_person_id"
                      placeholder="请填写法人发生在号，可通过法人身份证识别"
                    ></el-input
                  ></el-form-item>
                  <el-form-item
                    label="法人身份证有效期："
                    prop="legal_person_id_start_date"
                  >
                    <el-col :span="8">
                      <el-date-picker
                        type="date"
                        placeholder="开始日期"
                        v-model="shop_info.legal_person_id_start_date"
                        style="width: 100%;"
                        @change="getDate($event, 'legal_person_id_start_date')"
                      ></el-date-picker>
                    </el-col>
                    <el-col :span="1">-</el-col>
                    <el-col :span="8">
                      <el-date-picker
                        type="date"
                        placeholder="截止日期(长期则不选)"
                        v-model="shop_info.legal_person_id_expire_in"
                        @change="getDate($event, 'legal_person_id_expire_in')"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-col>
                  </el-form-item>

                  <el-form-item label="联系人：" prop="contact_man"
                    ><el-input
                      v-model="shop_info.contact_man"
                      placeholder="一般填业务员的姓名"
                    ></el-input
                  ></el-form-item>
                  <el-form-item label="联系人手机号：" prop="mobile_no"
                    ><el-input
                      v-model="shop_info.mobile_no"
                      placeholder="一般填业务员的手机号码"
                    ></el-input
                  ></el-form-item>
                  <el-form-item label="店铺电话：" prop="phone">
                    <el-input
                      v-model="shop_info.phone"
                      placeholder="需填写店铺负责人的手机号码"
                    ></el-input
                  ></el-form-item>
                  <el-form-item label="服务电话：" prop="service_phone">
                    <el-input
                      v-model="shop_info.service_phone"
                      placeholder="填写店铺的客服电话"
                    ></el-input
                  ></el-form-item>
                  <el-form-item label="店铺传真："
                    ><el-input
                      v-model="shop_info.fax"
                      placeholder="店铺传真"
                    ></el-input
                  ></el-form-item>
                  <el-form-item label="店铺邮箱："
                    ><el-input
                      v-model="shop_info.e_mail"
                      placeholder="店铺电子邮箱"
                    ></el-input
                  ></el-form-item>
                </el-form>
              </el-scrollbar>
            </div>
          </div>
          <div v-show="active == 2">
            <div
              :style="el_steps == 'el-steps' ? 'height:500px' : 'height:440px'"
            >
              <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%">
                <el-form
                  label-width="180px"
                  label-position="right："
                  :model="shop_info"
                  :rules="bankrules"
                  ref="bankForm"
                >
                  <el-form-item label="开户银行卡照片：" prop="img_bank_card">
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'bank'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                    >
                      <template slot="centerName">
                        银行卡
                      </template>
                    </uploadImg>
                  </el-form-item>
                  <el-form-item label="结算银行卡号：" prop="account_code"
                    ><el-input
                      v-model="shop_info.account_code"
                      placeholder="填写结算银行银行卡账号"
                    ></el-input
                  ></el-form-item>
                  <el-form-item label="银行名称：" prop="bank_name">
                    <el-select
                      v-model="shop_info.bank_name"
                      filterable
                      placeholder="开户银行名称，若列表中没有则选择其他银行"
                    >
                      <el-option
                        v-for="item in bank_name_options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="开户银行省市：" prop="bank_province">
                    <el-row>
                      <el-col :span="6">
                        <div id="bank_select">
                          <el-select
                            v-model="shop_info.bank_province"
                            filterable
                            placeholder="选择省"
                            @change="getCity"
                          >
                            <el-option
                              v-for="item in province_option"
                              :key="item.value"
                              :label="item.label"
                              :value="item.label"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </el-col>
                      <el-col :span="5"></el-col>
                      <el-col :span="6">
                        <div id="bank_select">
                          <el-select
                            v-model="bank_city"
                            filterable
                            placeholder="选择市"
                            style="width:200px"
                            @change="getOpenBank"
                          >
                            <el-option
                              v-for="item in city_option"
                              :key="item.value"
                              :label="item.label"
                              :value="item.label"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item label="开户银行名称：" prop="open_bank_name">
                    <!-- <el-input
                    v-model="shop_info.open_bank_name"
                    placeholder="详细的开户银行含支行的名称"
                  ></el-input> -->
                    <el-select
                      v-model="shop_info.open_bank_name"
                      filterable
                      placeholder="选择开户行支行（可模糊查询）"
                      style="width:200px"
                      @change="getOpenBnakName"
                    >
                      <!-- @change="" -->
                      <el-option
                        v-for="item in open_bank_options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="服务费率：" prop="service_charge">
                    <el-input
                      v-model="shop_info.service_charge"
                      placeholder="请输入服务费率（应在0.25~0.6之间）"
                      max="0.6"
                      min="0.2"
                      maxlength="5"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="受益人为法人：" prop="wxradio">
                    <el-radio-group
                      @change="wxradioChange"
                      v-model="shop_info.wxradio"
                    >
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="银行卡账号名称：">
                    <el-input
                      :disabled="shop_info.wxradio == 1 ? true : false"
                      v-model="shop_info.account_name"
                      placeholder="填写银行卡开户账号名称"
                    ></el-input
                  ></el-form-item>
                  <el-form-item
                    v-if="shop_info.wxradio == 2"
                    label="受益人身份证："
                    prop="img_beneficiary_id_front"
                  >
                    <el-row>
                      <el-col :span="9">
                        <uploadImg
                          class="uploadImg"
                          :imgTitle="'beneficiary_zm'"
                          @getReturn="getReturn"
                          @removeImg="removeImg"
                          style="display:inline-block"
                        >
                          <template slot="centerName">
                            受益人身份证正面
                          </template>
                        </uploadImg>
                      </el-col>
                      <el-col :span="7">
                        <uploadImg
                          class="uploadImg"
                          :imgTitle="'beneficiary_fm'"
                          @getReturn="getReturn"
                          @removeImg="removeImg"
                          style="display:inline-block;"
                        >
                          <template slot="centerName">
                            受益人身份证反面
                          </template>
                        </uploadImg>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item
                    v-if="shop_info.wxradio == 2"
                    label="受益人姓名："
                    prop="beneficiary_name"
                  >
                    <el-input v-model="shop_info.beneficiary_name"></el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="shop_info.wxradio == 2"
                    label="受益人身份证号："
                    prop="beneficiary_id"
                  >
                    <el-input v-model="shop_info.beneficiary_id"></el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="shop_info.wxradio == 2"
                    label="受益人身份证有效期："
                    prop="beneficiary_id_start_date"
                  >
                    <el-col :span="8">
                      <el-date-picker
                        type="date"
                        placeholder="开始日期"
                        v-model="shop_info.beneficiary_id_start_date"
                        style="width: 100%;"
                        @change="getDate($event, 'beneficiary_id_start_date')"
                      ></el-date-picker>
                    </el-col>
                    <el-col :span="1">-</el-col>
                    <el-col :span="8">
                      <el-date-picker
                        type="date"
                        placeholder="截止日期(长期则不选)"
                        v-model="shop_info.beneficiary_id_expire_in"
                        @change="getDate($event, 'beneficiary_id_expire_in')"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-col>
                  </el-form-item>

                  <el-form-item
                    v-if="shop_info.wxradio == 2"
                    label="授权书："
                    prop="img_warrant"
                  >
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'warrant'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                    >
                      <template slot="centerName">
                        授权书
                      </template>
                    </uploadImg>
                  </el-form-item>
                </el-form>
              </el-scrollbar>
            </div>
          </div>

          <div v-show="active == 3">
            <div
              :style="el_steps == 'el-steps' ? 'height:500px' : 'height:440px'"
            >
              <el-scrollbar wrapStyle="overflow-x:hidden;" style="height:100%">
                <el-divider content-position="left">
                  <h2>资质信息</h2>
                </el-divider>
                <el-form
                  label-width="180px"
                  label-position="right"
                  class="form-one"
                >
                  <el-form-item label="是否预授权：">
                    {{ shop_info.is_pre_auth == 1 ? "是" : "否" }}
                  </el-form-item>
                  <el-form-item style="margin-top:30px" label="店铺密码：">{{
                    shop_info.pass_word
                  }}</el-form-item>
                  <el-form-item label="营业执照照片：">
                    <img
                      :src="
                        shop_info.img_license
                          ? $url +
                            'media/image/' +
                            shop_info.img_license +
                            '.jpg'
                          : ''
                      "
                      style="height:660px;width:450px"
                      alt=""
                      v-show="shop_info.img_license"
                    />
                  </el-form-item>
                  <el-form-item label="店铺名称：">{{
                    shop_info.mch_name
                  }}</el-form-item>
                  <el-form-item label="营业执照id：">{{
                    shop_info.license_code
                  }}</el-form-item>
                  <el-form-item label=" 营业执照有效期："
                    >{{ shop_info.license_start_date }}到{{
                      shop_info.license_expire_in
                        ? shop_info.license_expire_in
                        : ""
                    }}</el-form-item
                  >
                  <el-form-item label="店铺地址：">{{
                    shop_info.address
                  }}</el-form-item>

                  <el-form-item label="资质类型：">
                    {{ getMchType() }}
                  </el-form-item>
                  <el-form-item label="经营范围：">
                    {{ getBusinessScope() }}
                  </el-form-item>

                  <el-form-item label="店铺省市区：">{{
                    address_name
                  }}</el-form-item>

                  <el-form-item label="店铺门头照：">
                    <img
                      :src="
                        shop_info.img_door
                          ? $url + 'media/image/' + shop_info.img_door + '.jpg'
                          : ''
                      "
                      style="height:400px;width:586px"
                      v-show="shop_info.img_door"
                      alt=""
                    />
                  </el-form-item>

                  <el-form-item label="店铺内景照片：">
                    <img
                      :src="
                        shop_info.img_in_door
                          ? $url +
                            'media/image/' +
                            shop_info.img_in_door +
                            '.jpg'
                          : ''
                      "
                      style="height:400px;width:586px"
                      alt=""
                      v-show="shop_info.img_in_door"
                    />
                  </el-form-item>
                  <el-form-item label="收银台照片：">
                    <img
                      :src="
                        shop_info.img_cashier
                          ? $url +
                            'media/image/' +
                            shop_info.img_cashier +
                            '.jpg'
                          : ''
                      "
                      style="height:400px;width:586px"
                      v-show="shop_info.img_cashier"
                      alt=""
                    />
                  </el-form-item>
                </el-form>
                <el-divider content-position="left">
                  <h2>基础信息</h2>
                </el-divider>
                <el-form
                  label-width="180px"
                  label-position="right"
                  ref="wxFormRef"
                  class="form-one"
                >
                  <el-form-item label="法人身份证：">
                    <img
                      :src="
                        shop_info.img_legal_id_front
                          ? $url +
                            'media/image/' +
                            shop_info.img_legal_id_front +
                            '.jpg'
                          : ''
                      "
                      style="height:225px;width:330px"
                      v-show="shop_info.img_legal_id_front"
                      alt=""
                    />
                    <img
                      :src="
                        shop_info.img_legal_id_back
                          ? $url +
                            'media/image/' +
                            shop_info.img_legal_id_back +
                            '.jpg'
                          : ''
                      "
                      style="height:225px;width:330px"
                      v-show="shop_info.img_legal_id_back"
                      alt=""
                    />
                  </el-form-item>
                  <el-form-item label="法人姓名：">{{
                    shop_info.legal_person_name
                  }}</el-form-item>
                  <el-form-item label="法人身份证号：">{{
                    shop_info.legal_person_id
                  }}</el-form-item>

                  <el-form-item label="法人身份证有效期：">
                    {{ shop_info.legal_person_id_start_date }}到{{
                      shop_info.legal_person_id_expire_in
                    }}
                  </el-form-item>
                  <el-form-item label="联系人：">{{
                    shop_info.contact_man
                  }}</el-form-item>
                  <el-form-item label="联系人手机号：">{{
                    shop_info.mobile_no
                  }}</el-form-item>
                  <el-form-item label="店铺电话：">{{
                    shop_info.phone
                  }}</el-form-item>
                  <el-form-item label="服务电话：">{{
                    shop_info.service_phone
                  }}</el-form-item>
                  <el-form-item label="店铺传真：">{{
                    shop_info.fax
                  }}</el-form-item>
                  <el-form-item label="店铺邮箱：">{{
                    shop_info.e_mail
                  }}</el-form-item>
                </el-form>
                <el-divider content-position="left">
                  <h2>结算信息</h2>
                </el-divider>
                <el-form
                  label-width="180px"
                  label-position="right："
                  ref="wxFormRef"
                  class="form-one"
                >
                  <el-form-item label="开户银行卡照片：">
                    <img
                      :src="
                        shop_info.img_bank_card
                          ? $url +
                            'media/image/' +
                            shop_info.img_bank_card +
                            '.jpg'
                          : ''
                      "
                      style="height:400px;width:586px"
                      v-show="shop_info.img_bank_card"
                      alt=""
                    />
                  </el-form-item>
                  <el-form-item label="结算银行卡号：">{{
                    shop_info.account_code
                  }}</el-form-item>
                  <el-form-item label="银行卡账号名称：">{{
                    shop_info.account_name
                  }}</el-form-item>
                  <el-form-item label="银行名称：">{{
                    shop_info.bank_name
                  }}</el-form-item>
                  <el-form-item label="开户银行名称：">{{
                    shop_info.open_bank_name
                  }}</el-form-item>
                  <el-form-item label="开户银行银联号：">{{
                    shop_info.open_bank_code
                  }}</el-form-item>

                  <el-form-item label="服务费率：">
                    {{ shop_info.service_charge }}
                  </el-form-item>
                  <el-form-item label="受益人为法人："
                    >{{ shop_info.wxradio == 1 ? "是" : "否" }}
                  </el-form-item>
                  <el-form-item label="受益人身份证：">
                    <img
                      :src="
                        shop_info.img_beneficiary_id_front
                          ? $url +
                            'media/image/' +
                            shop_info.img_beneficiary_id_front +
                            '.jpg'
                          : ''
                      "
                      style="height:225px;width:330px"
                      v-show="shop_info.img_beneficiary_id_front"
                      alt=""
                    />
                    <img
                      :src="
                        shop_info.img_beneficiary_id_back
                          ? $url +
                            'media/image/' +
                            shop_info.img_beneficiary_id_back +
                            '.jpg'
                          : ''
                      "
                      style="height:225px;width:330px"
                      v-show="shop_info.img_beneficiary_id_back"
                      alt=""
                    />
                  </el-form-item>
                  <el-form-item label="受益人姓名：">
                    {{ shop_info.beneficiary_name }}
                  </el-form-item>
                  <el-form-item label="受益人身份证号：">{{
                    shop_info.beneficiary_id
                  }}</el-form-item>
                  <el-form-item label="受益人人身份证有效期：">
                    {{ shop_info.beneficiary_id_start_date }}到{{
                      shop_info.beneficiary_id_expire_in
                    }}
                  </el-form-item>

                  <el-form-item v-if="shop_info.wxradio == 2" label="授权书：">
                    <img
                      :src="
                        shop_info.img_warrant
                          ? $url +
                            'media/image/' +
                            shop_info.img_warrant +
                            '.jpg'
                          : ''
                      "
                      style="height:400px;width:586px"
                      v-show="shop_info.img_warrant"
                      alt=""
                    />
                  </el-form-item>
                </el-form>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="button-bottom">
        <el-button v-if="active == 3" type="primary" plain @click="sure = false"
          >信息确认完毕</el-button
        >
        <el-button @click="pre">上一步</el-button>
        <el-button type="primary" @click="submit" :disabled="sure"
          >提交</el-button
        >
        <el-button @click="next">下一步</el-button>
        <el-button @click="reset" type="danger" plain>重置</el-button>
      </div>
    </div>
  </div>
</template>
<script>
//api
import {
  GetBankProvince,
  GetBankcity,
  GetBankCode,
  GenerateMerchant
} from "@/api/index";
import "@/css/global.css";
import uploadImg from "@/components/uploadImg.vue";
import { province, map } from "@/js/map";
import { MCC } from "@/js/MCC";
export default {
  name: "feed",
  inject: ["reload"],
  components: {
    uploadImg
  },
  async created() {
    this.provincearr = province;
    this.map = map;
    this.MCC = MCC;
    var { data: res } = await GetBankProvince();
    /* TODO
    此函数 对象名 'ba_bank_info' 无效。"
    */
    console.log("MCC:", res);
    try {
      for (var i = 0; i < res.resp_data.length; i++) {
        this.province_option.push({
          label: res.resp_data[i],
          value: i
        });
      }
    } catch (e) {
      console.log(e);
    }
  },
  mounted() {
    window.localStorage.setItem(
      "pixel",
      window.screen.height * window.screen.width
    );
    var resolution = localStorage.getItem("pixel");
    if (resolution <= 1400 * 900) {
      this.el_steps = "el-steps-sm";
    }
    if (resolution > 1400 * 900) {
      this.el_steps = "el-steps";
    }
  },
  data() {
    return {
      shop_info: {
        //省市区编号
        address_code: "",
        /// 店铺密码
        pass_word: "",
        /// 店铺全名称 优选易购生活超市-颐和店
        mch_name: "",
        /// 营业执照ID
        license_code: "",
        /// 法人姓名
        legal_person_name: "",
        /// 法人身份证号
        legal_person_id: "",
        /// 联系人 日常联系人通常是业务员
        contact_man: "",
        /// 联系人的手机号码
        mobile_no: "",
        /// 店铺地址
        address: "",
        /// 店铺电话
        phone: "",
        /// 服务电话 给用户联系的电话展示在店铺中
        service_phone: "",
        /// 传真
        fax: "",
        /// 电子邮箱
        e_mail: "",
        /// 结算银行卡的账号名称
        account_name: "",
        /// 结算账号
        account_code: "",
        //开户银行
        bank_name: "",
        //开户银行名称含支行
        open_bank_name: "",

        ///银行卡
        img_bank_card: "",
        ///门头照
        img_door: "",
        //内景
        img_in_door: "",
        //收银台
        img_cashier: "",
        //授权书
        img_warrant: "",
        /// 法人身份证正面人像面
        img_legal_id_front: "",
        /// 法人身份证反面
        img_legal_id_back: "",
        /// 营业执照照片
        img_license: "",
        //受益人
        beneficiary_name: "",
        beneficiary_id: "",
        img_beneficiary_id_front: "",
        img_beneficiary_id_back: "",

        beneficiary_id_start_date: "",
        beneficiary_id_expire_in: "",

        //商铺类型
        mch_type: "",
        //经营范围
        business_scope: "",

        //营业执照开始有效期
        license_start_date: "",
        //营业执照结束有效期
        license_expire_in: "",

        //法人身份证开始有效期
        legal_person_id_start_date: "",
        //法人身份证结束有效期
        legal_person_id_expire_in: "",

        //服务费率
        service_charge: "",
        //是否预授权
        is_pre_auth: 2,
        //开户行银联号
        open_bank_code: "",
        wxradio: "",
        //开户银行省不是必要字段
        bank_province: ""
      },
      baserules: {
        address_code: [
          { required: true, message: "请选择店铺省市区", trigger: "change" }
        ],
        img_license: [
          { required: true, message: "请上传营业执照", trigger: "change" }
        ],
        pass_word: [
          { required: true, message: "请填写店铺密码", trigger: "change" },
          {
            min: 3,
            max: 10,
            message: "长度在 3 到 10 个字符",
            trigger: "change"
          }
        ],
        is_pre_auth: [
          { required: true, message: "请选择是否预授权", trigger: "change" }
        ],
        mch_name: [
          { required: true, message: "请填写店铺名称", trigger: "change" }
        ],
        license_code: [
          { required: true, message: "请填写店铺营业执照id", trigger: "change" }
        ],
        license_start_date: [
          {
            required: true,
            message: "请填写营业执照开始有效期",
            trigger: "change"
          }
        ],
        address: [
          { required: true, message: "请填写店铺地址", trigger: "change" }
        ],
        mch_type: [
          { required: true, message: "请选店铺择资质类型", trigger: "change" }
        ],
        business_scope: [
          { required: true, message: "请选择店铺的经营范围", trigger: "change" }
        ],
        img_door: [
          { required: true, message: "请上传店铺门头照片", trigger: "change" }
        ],
        img_in_door: [
          { required: true, message: "请上传店铺内景照片", trigger: "change" }
        ]
      },
      legalrules: {
        legal_person_name: [
          { required: true, message: "请填写法人姓名", trigger: "change" }
        ],
        legal_person_id: [
          { required: true, message: "请填写法人身份证号", trigger: "change" }
        ],
        img_legal_id_front: [
          {
            required: true,
            message: "请上传法人身份证正面照片",
            trigger: "change"
          }
        ],
        img_legal_id_back: [
          {
            required: true,
            message: "请上传法人身份证反面照片",
            trigger: "change"
          }
        ],
        contact_man: [
          { required: true, message: "请填写联系人姓名", trigger: "change" }
        ],
        mobile_no: [
          { required: true, message: "请填写联系人电话", trigger: "change" }
        ],
        legal_person_id_start_date: [
          {
            required: true,
            message: "请选择法人身份证有效期",
            trigger: "change"
          }
        ],
        phone: [
          { required: true, message: "请填写店铺电话", trigger: "change" }
        ],
        service_phone: [
          { required: true, message: "请填写服务电话", trigger: "change" }
        ]
      },
      bankrules: {
        account_code: [
          { required: true, message: "请选择结算银行卡号", trigger: "change" }
        ],
        bank_name: [
          { required: true, message: "请选择结算银行名称", trigger: "change" }
        ],
        open_bank_name: [
          {
            required: true,
            message: "请选择开户银行名称（含支行名称）",
            trigger: "change"
          }
        ],
        img_bank_card: [
          { required: true, message: "请选择上传银行卡照片", trigger: "change" }
        ],
        service_charge: [
          { required: true, message: "请填写服务费率", trigger: "change" }
        ],
        beneficiary_name: [
          { required: true, message: "请填写受益人名称", trigger: "change" }
        ],
        beneficiary_id: [
          {
            required: true,
            message: "请填写受益人身份证号码",
            trigger: "change"
          }
        ],
        img_beneficiary_id_front: [
          { required: true, message: "请上传受益人身份证", trigger: "change" }
        ],
        beneficiary_id_start_date: [
          {
            required: true,
            message: "请填写受益人身份证开始日期",
            trigger: "change"
          }
        ],
        beneficiary_id_expire_in: [
          {
            required: true,
            message: "请填写受益人身份证截止日期",
            trigger: "change"
          }
        ],
        img_warrant: [
          { required: true, message: "请上传授权书", trigger: "change" }
        ],
        wxradio: [
          {
            required: true,
            message: "请选择受益人是否是法人",
            trigger: "change"
          }
        ],
        bank_province: [
          {
            required: true,
            message: "请选择开户银行省市",
            trigger: "change"
          }
        ],
        img_bank_card: [
          {
            required: true,
            message: "请上传开户银行卡照片",
            trigger: "change"
          }
        ]
      },
      mch_type_options: [
        { label: "自然人", value: "0" },
        { label: "个体户", value: "1" },
        { label: "企业", value: "2" }
      ],
      el_steps: "",
      //操作时间
      oper_date: "",
      //状态
      state: "",
      sure: true, //是否确定提交
      active: 0,
      provincearr: [],
      map: [],
      MCC: [],
      address_name: "",
      nonce_str: "",
      bank_name_options: [
        { value: "1", label: "中国农业发展银行" },
        { value: "2", label: "其他银行" },
        { value: "3", label: "广发银行" },
        { value: "4", label: "村镇银行" },
        { value: "5", label: "上海浦东发展银行" },
        { value: "6", label: "中国农业银行" },
        { value: "7", label: "渤海银行" },
        { value: "8", label: "中国工商银行" },
        { value: "9", label: "中国银行" },
        { value: "10", label: "华夏银行" },
        { value: "11", label: "中国民生银行" },
        { value: "12", label: "平安银行" },
        { value: "13", label: "中国人民银行" },
        { value: "14", label: "交通银行" },
        { value: "15", label: "中国建设银行" },
        { value: "16", label: "招商银行" },
        { value: "17", label: "城市商业银行" },
        { value: "18", label: "中国邮政储蓄银行" },
        { value: "19", label: "中信银行" },
        { value: "20", label: "农村商业银行" },
        { value: "21", label: "兴业银行" },
        { value: "22", label: "中国光大银行" },
        { value: "23", label: "浙商银行" }
      ],
      city_option: [],
      province_option: [],

      bank_city: "",
      open_bank_options: [],
      bank_name_value: ""
    };
  },

  methods: {
    wxradioChange(res) {
      if (res == 2) {
        this.shop_info.account_name = "";
        this.shop_info.beneficiary_id = "";
        this.shop_info.beneficiary_name = "";
        this.shop_info.img_beneficiary_id_front = "";
        this.shop_info.img_beneficiary_id_back = "";
        this.shop_info.beneficiary_id_start_date = "";
        this.shop_info.beneficiary_id_expire_in = "";
      } else if (res == 1) {
        this.shop_info.account_name = this.shop_info.legal_person_name;
      }
    },
    getOpenBnakName() {
      for (var i = 0; i < this.open_bank_options.length; i++) {
        if (this.open_bank_options[i].label == this.shop_info.open_bank_name) {
          this.shop_info.open_bank_code = this.open_bank_options[i].value;
        }
      }
    },
    async getOpenBank() {
      var data = {
        province: this.shop_info.bank_province,
        city: this.bank_city
      };
      var { data: res } = await GetBankCode(JSON.stringify(data));
      if (res.resp_data.length > 0) {
        var arr = res.resp_data;
        this.open_bank_options = [];
        if (this.shop_info.bank_name == "其他银行") {
          for (var i = 0; i < arr.length; i++) {
            this.open_bank_options.push({
              label: arr[i].full_name,
              value: arr[i].bank_code
            });
          }
        } else {
          for (var x in arr) {
            if (arr[x].full_name.indexOf(this.shop_info.bank_name) >= 0) {
              this.open_bank_options.push({
                label: arr[x].full_name,
                value: arr[x].bank_code
              });
            }
          }
        }
      }
    },
    async getCity() {
      this.city_option = [];
      var { data: res } = await GetBankcity(this.shop_info.bank_province);
      for (var i = 0; i < res.resp_data.length; i++) {
        this.city_option.push({
          label: res.resp_data[i],
          value: i
        });
      }
    },
    getReturn(res) {
      if (
        res.title == "beneficiary_fm" ||
        (res.title == "beneficiary_zm" && this.shop_info.wxradio == "1")
      )
        return;
      switch (res.title) {
        case "yyzz":
          if (res.img) {
            this.shop_info.img_license = res.img;
          }
          if (res.img_info) {
            this.shop_info.license_start_date = this.subStitute(
              res.img_info.DateEstablishment
            );
            if (res.img_info.DateValidity == "无") {
              this.shop_info.license_expire_in = "";
            } else {
              this.shop_info.license_expire_in = this.subStitute(
                res.img_info.DateValidity
              );
            }
            this.shop_info.mch_name = res.img_info.CommpanyName;
            this.shop_info.license_code = res.img_info.LicenseCode;
            this.shop_info.address = res.img_info.Address;
          } else {
            this.warnMessage("营业执照信息获取失败，请重试");
          }
          break;
        case "zm":
          if (res.img) {
            this.shop_info.img_legal_id_front = res.img;
          }
          if (res.img_info) {
            this.shop_info.legal_person_name = res.img_info.name;
            this.shop_info.legal_person_id = res.img_info.number;
          } else {
            this.warnMessage("法人身份证正面上传失败，请重试");
          }
          break;
        case "beneficiary_zm":
          if (res.img) {
            this.shop_info.img_beneficiary_id_front = res.img;
          }
          if (res.img_info) {
            this.shop_info.beneficiary_name = res.img_info.name;
            this.shop_info.beneficiary_id = res.img_info.number;
          } else {
            this.warnMessage("受益人身份证正面上传失败，请重试");
          }
          break;
        case "fm":
          if (res.img) {
            this.shop_info.img_legal_id_back = res.img;
          }
          if (res.img_info) {
            this.shop_info.legal_person_id_start_date = res.img_info.begin;
            this.shop_info.legal_person_id_expire_in = res.img_info.end;
          } else {
            this.warnMessage("法人身份证反面上传失败，请重试");
          }
          break;
        case "beneficiary_fm":
          if (res.img) {
            this.shop_info.img_beneficiary_id_back = res.img;
          }
          if (res.img_info) {
            this.shop_info.beneficiary_id_start_date = res.img_info.begin;
            this.shop_info.beneficiary_id_expire_in = res.img_info.end;
          } else {
            this.warnMessage("受益人身份证反面上传失败，请重试");
          }
          break;
        case "bank":
          if (res.img) {
            this.shop_info.img_bank_card = res.img; //银行卡照片
          }
          if (res.img_info) {
            this.shop_info.account_code = res.img_info.number;
          } else {
            this.warnMessage("银行卡号获取失败，请重试");
          }
          break;
        //门头store_entrance
        case "store_entrance":
          if (res.img) {
            this.shop_info.img_door = res.img;
          }
          break;
        //内部indoor
        case "indoor":
          if (res.img) {
            this.shop_info.img_in_door = res.img;
          }
          break;
        //收银台cashier
        case "cashier":
          if (res.img) {
            this.shop_info.img_cashier = res.img;
          }
          break;
        //授权书warrant
        case "warrant":
          if (res.img) {
            this.shop_info.img_warrant = res.img;
          }
          break;
      }
    },
    subStitute(strr) {
      if (
        strr == "长期" ||
        strr == "无" ||
        strr == "年月日" ||
        str == "" ||
        str == null ||
        strr == undefined
      ) {
        return "";
      }
      var str = "";
      for (var key in strr) {
        if (key == 4 || key == 7) {
          str += "-";
        } else if (key == 10) {
        } else {
          str += strr[key];
        }
      }
      return str;
    },
    // 删除已经上传的图片
    removeImg(imgTitle) {
      switch (imgTitle) {
        case "fm":
          this.shop_info.img_legal_id_back = "";
          this.shop_info.legal_person_id_start_date = "";
          this.shop_info.legal_person_id_expire_in = "";
          break;
        case "zm":
          this.shop_info.img_legal_id_front = "";
          this.shop_info.beneficiary_name = "";
          this.shop_info.beneficiary_id = "";
          break;
        case "yyzz":
          this.shop_info.img_license = "";
          this.shop_info.license_start_date = "";
          this.shop_info.license_expire_in = "";
          this.shop_info.mch_name = "";
          this.shop_info.address = "";
          this.shop_info.license_code = "";
          break;
        case "bank":
          this.shop_info.img_bank_card = "";
          this.shop_info.account_code = "";
          break;
        case "indoor":
          this.shop_info.img_in_door = "";
          break;
        case "cashier":
          this.shop_info.img_cashier = "";
          break;
        case "store_entrance":
          this.shop_info.img_door = "";
          break;
        case "warrant":
          this.shop_info.img_warrant = "";
          break;
        case "beneficiary_zm":
          this.shop_info.img_beneficiary_id_front = "";
          this.shop_info.beneficiary_name = "";
          this.shop_info.beneficiary_id = "";
          break;
        case "beneficiary_fm":
          this.shop_info.img_beneficiary_id_back = "";
          this.shop_info.beneficiary_id_start_date = "";
          this.shop_info.beneficiary_id_expire_in = "";
          break;
      }
    },
    getDate(date, e) {
      if (date == null) {
        return;
      }
      this.shop_info[e] = this.formatDate(date);
    },

    setDate() {},
    next() {
      this.active++;
      if (this.active == 0) {
        this.$refs.baseForm.validate(valid => {
          if (valid) {
            this.active++;
            return;
          } else {
            return;
          }
        });
        return;
      }

      if (this.active == 1) {
        this.$refs.legalForm.validate(valid => {
          if (valid) {
            this.active++;
            return;
          } else {
            return;
          }
        });
        return;
      }

      if (this.active == 2) {
        this.$refs.bankForm.validate(valid => {
          if (valid) {
            this.active++;
            return;
          } else {
            return;
          }
        });
      }
      if (this.active >= 3) {
        this.active = 3;
        if (this.shop_info.wxradio == 1) {
          this.shop_info.beneficiary_id = this.shop_info.legal_person_id;
          this.shop_info.beneficiary_name = this.shop_info.legal_person_name;
          this.shop_info.img_beneficiary_id_front = this.shop_info.img_legal_id_front;
          this.shop_info.img_beneficiary_id_back = this.shop_info.img_legal_id_back;
          this.shop_info.beneficiary_id_start_date = this.shop_info.legal_person_id_start_date;
          this.shop_info.beneficiary_id_expire_in = this.shop_info.legal_person_id_expire_in;
        }
      }
    },
    pre() {
      if (this.active-- < 1) this.active = 0;
    },
    async submit() {
      this.getDate(new Date(), "oper_date");

      this.nonce_str = this.getKey();
      if (
        this.shop_info.license_expire_in == null ||
        this.shop_info.license_expire_in == undefined
      ) {
        this.shop_info.license_expire_in = "";
      }
      var object = {
        nonce_str: this.nonce_str,
        access_token: this.access_token,
        service_id: localStorage.getItem("service_id"),
        mch: {
          pass_word: this.shop_info.pass_word,
          mch_name: this.shop_info.mch_name,
          license_code: this.shop_info.license_code,
          legal_person_name: this.shop_info.legal_person_name,
          legal_person_id: this.shop_info.legal_person_id,
          contact_man: this.shop_info.contact_man,
          mobile_no: this.shop_info.mobile_no,
          address: this.shop_info.address,
          phone: this.shop_info.phone,
          service_phone: this.shop_info.service_phone,
          fax: this.shop_info.fax,
          e_mail: this.shop_info.e_mail,
          account_name: this.shop_info.account_name,
          account_code: this.shop_info.account_code,
          bank_name: this.shop_info.bank_name,
          open_bank_name: this.shop_info.open_bank_name,
          open_bank_code: this.shop_info.open_bank_code,
          img_bank_card: this.shop_info.img_bank_card,
          img_door: this.shop_info.img_door,
          img_in_door: this.shop_info.img_in_door,
          img_cashier: this.shop_info.img_cashier,
          img_warrant: this.shop_info.img_warrant,
          img_legal_id_front: this.shop_info.img_legal_id_front,
          img_legal_id_back: this.shop_info.img_legal_id_back,
          img_license: this.shop_info.img_license,
          beneficiary_id: this.shop_info.beneficiary_id,
          beneficiary_name: this.shop_info.beneficiary_name,
          img_beneficiary_id_front: this.shop_info.img_beneficiary_id_front,
          img_beneficiary_id_back: this.shop_info.img_beneficiary_id_back,
          service_charge: this.shop_info.service_charge,
          is_pre_auth: this.shop_info.is_pre_auth,
          oper_date: this.shop_info.oper_date,
          business_scope: this.shop_info.business_scope,
          license_start_date: this.shop_info.license_start_date,
          license_expire_in: this.shop_info.license_expire_in,
          legal_person_id_start_date: this.shop_info.legal_person_id_start_date,
          legal_person_id_expire_in: this.shop_info.legal_person_id_expire_in,
          mch_type: this.shop_info.mch_type,
          beneficiary_id_start_date: this.shop_info.beneficiary_id_start_date,
          beneficiary_id_expire_in: this.shop_info.beneficiary_id_expire_in,
          address_code: this.shop_info.address_code,
          state: ""
        }
      };
      var sign = this.getSign(object);
      let data = {
        nonce_str: this.nonce_str,
        access_token: this.access_token,
        service_id: localStorage.getItem("service_id"),
        sign: sign,
        mch: {
          pass_word: await this.encrypt(this.shop_info.pass_word),
          mch_name: this.shop_info.mch_name,
          license_code: this.shop_info.license_code,
          legal_person_name: this.shop_info.legal_person_name,
          legal_person_id: await this.encrypt(this.shop_info.legal_person_id),
          contact_man: this.shop_info.contact_man,
          mobile_no: await this.encrypt(this.shop_info.mobile_no),
          address: this.shop_info.address,
          phone: this.shop_info.phone,
          service_phone: this.shop_info.service_phone,
          fax: this.shop_info.fax,
          e_mail: this.shop_info.e_mail,
          account_name: this.shop_info.account_name,
          account_code: this.shop_info.account_code,
          bank_name: this.shop_info.bank_name,
          open_bank_name: this.shop_info.open_bank_name,
          open_bank_code: this.shop_info.open_bank_code,
          img_bank_card: this.shop_info.img_bank_card,
          img_door: this.shop_info.img_door,
          img_in_door: this.shop_info.img_in_door,
          img_cashier: this.shop_info.img_cashier,
          img_warrant: this.shop_info.img_warrant,
          img_legal_id_front: this.shop_info.img_legal_id_front,
          img_legal_id_back: this.shop_info.img_legal_id_back,
          img_license: this.shop_info.img_license,
          beneficiary_id: await this.encrypt(this.shop_info.beneficiary_id),
          beneficiary_name: this.shop_info.beneficiary_name,
          img_beneficiary_id_front: this.shop_info.img_beneficiary_id_front,
          img_beneficiary_id_back: this.shop_info.img_beneficiary_id_back,
          service_charge: this.shop_info.service_charge,
          is_pre_auth: this.shop_info.is_pre_auth,
          oper_date: this.shop_info.oper_date,
          business_scope: this.shop_info.business_scope,
          license_start_date: this.shop_info.license_start_date,
          license_expire_in: this.shop_info.license_expire_in,
          legal_person_id_start_date: this.shop_info.legal_person_id_start_date,
          legal_person_id_expire_in: this.shop_info.legal_person_id_expire_in,
          mch_type: this.shop_info.mch_type,
          beneficiary_id_start_date: this.shop_info.beneficiary_id_start_date,
          beneficiary_id_expire_in: this.shop_info.beneficiary_id_expire_in,
          address_code: this.shop_info.address_code,
          state: ""
        }
      };
      var { data: res } = await GenerateMerchant(JSON.stringify(data));
      if (
        res.return_code == "SUCCESS" &&
        res.result_code == "SUCCESS" &&
        res.resp_data.merchant_id
      ) {
        this.successMessage("商户入驻成功");
      } else {
        if (res.result_code == "FAIL" && res.result_msg) {
          this.$message.error(res.result_msg);
        } else {
          this.$message.error("失败 " + JSON.stringify(res));
        }
        console.log("错误返回值", res);
      }
    },
    //资质类型
    getMchType() {
      for (var i = 0; i < 3; i++) {
        if (this.mch_type_options[i].value == this.shop_info.mch_type) {
          return this.mch_type_options[i].label;
        }
      }
    },
    //经营范围
    getBusinessScope() {
      for (var i = 0; i < this.MCC.length; i++) {
        if (this.MCC[i].value == this.shop_info.business_scope) {
          return this.MCC[i].label;
        }
      }
    },
    async shophandleChange(e) {
      if (e.length == 0) {
        return;
      }
      this.shop_info.address_code = e[2];
      this.address_name = this.map[e[2]];
    },
    reset() {
      this.$confirm("执行重置操作所有内容将被清空，确定继续吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.reload();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  }
};
</script>
<style scoped>
.el-form-item >>> .el-input {
  width: 460px;
}
#bank_select >>> .el-input {
  width: 150px !important;
}
.div-item {
  display: inline-block;
  width: 33%;
  height: 40px;
  text-align: center;
  margin-bottom: 10px;
  line-height: 2.5;
  cursor: pointer;
}
.fa {
  width: 100%;
  height: 100%;
  background-color: #fff;
  min-height: 685px;
}
.el-steps {
  margin-top: 30px;
}
.el-steps-sm {
  transform: scale(0.8, 0.8);
  margin-top: 20px;
}
.el-step {
  height: 60px;
}
.box {
  width: 100%;
  margin-top: -20px;
  background-color: #fff !important;
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.box-small {
  height: 600px;
}
.el-form-info .el-form-item:nth-child(2n + 2) {
  margin-left: 30px;
}
.el-select {
  width: 100%;
}
.uploadImg {
  width: 110px;
  height: 75px;
}
.fa-el-form {
  width: 220px;
  height: 160px;
}
.card-form {
  display: inline-block;
  width: 832px;
  height: 450px;
  padding: 10px;
}
.button-bottom {
  width: 70%;
  display: flex;
  justify-content: right;
  margin: 20px 0 0 0;
}
.qualification-type-select {
  width: 200px;
}
.el-cascader-panel {
  height: 300px !important;
}
.el-cascader >>> .el-cascader-panel {
  height: 300px !important;
}
.el-form-pc {
  height: 672px;
}
h2 {
  margin: 0;
  padding: 0;
}
.form-one {
  color: rgb(1, 75, 153);
}
</style>
